import { nodeAttributeLabel } from "~/node";
import { invoiceCategoryTypeOptions } from ".";

export const invoiceCategoryTypeLabel = nodeAttributeLabel(
  invoiceCategoryTypeOptions
);
